import React, { useState, useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router'
import { Box, Tabs, Tab } from '@mui/material'
import Layout from '../layout/Layout'
import Entity from './Entity'
import TAN from './TAN'
import UserSetup from './UserSetup'
import AssignEntity from './AssignEntity'
import ComplianceMaster from './ComplianceMaster';
import { ROLE_CAPABILITIES } from '../../utils/role-capabilities.js';
import { useSelector } from 'react-redux'
import TabPanel from "../../components/common/TabPanel"

const AdminDashboard = () => {
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  const [activeTab, setActiveTab] = useState('entity')
  const roleTypes = useSelector(state => state.user.role)

  const roleConfig = ROLE_CAPABILITIES[roleTypes] || ROLE_CAPABILITIES.default;
  const tabs =[
    { key: 'entity', label: 'Entity', component: <Entity roleConfig={roleConfig} /> },
    { key: 'tan', label: 'Tan master', component: <TAN roleConfig={roleConfig} /> },
    { key: 'user', label: 'User setup', component: <UserSetup roleConfig={roleConfig} /> },
    { key: 'assign-entity', label: 'Assign entity', component: <AssignEntity roleConfig={roleConfig} roleTypes={roleTypes} /> },
    { key: 'compliance-master', label: 'Assign compliances', component: <ComplianceMaster roleConfig={roleConfig} roleTypes={roleTypes} /> }
  ]

  useEffect(() => {
    const step = searchParams.get('step')
    if (step && tabs.some((t) => t.key === step)) {7
      setActiveTab(step)
    }
  }, [searchParams])

  const handleTabChange = (event, newIndex) => {
    const newKey = tabs[newIndex].key
    setActiveTab(newKey)
    setSearchParams({ step: newKey })
    navigate('/admin?step=' + newKey, { replace: true })
  }

  return (
    <Layout>
      <Box sx={{ width: '100%' }}>
        {/* Tab Navigation */}
        <Box
          sx={{
            borderBottom: 1,
            borderColor: 'var(--border-strong)',
            background: '#FFFFFF',
          }}
        >
          <Tabs
            value={tabs.findIndex((t) => t.key === activeTab)}
            onChange={handleTabChange}
            aria-label="admin dashboard tabs"
            sx={{
              '& .MuiTab-root': {
                textTransform: 'none',
                fontWeight: 400,
                fontSize: '14px',
                padding: '12px 16px',
                color: 'var(--forbrand-secondary)',
                '&.Mui-selected': {
                  color: 'var(--forbrand-primary)',
                  fontWeight: 700,
                },
              },
              '& .MuiTabs-indicator': {
                backgroundColor: 'var(--forbrand-color)',
                height: 3,
              },
            }}
          >
            {tabs.map((tab, index) => (
              <Tab
                key={tab.key}
                label={tab.label}
                id={`admin-tab-${index}`}
                aria-controls={`admin-tabpanel-${index}`}
              />
            ))}
          </Tabs>
        </Box>

        {/* Tab Content */}
        {tabs.map((tab, index) => (
          <TabPanel
            key={tab.key}
            value={tabs.findIndex((t) => t.key === activeTab)}
            index={index}
          >
            {tab.component}
          </TabPanel>
        ))}
      </Box>
    </Layout>
  )
}

export default AdminDashboard
